import { abortAll, abortBatch, abortItem } from "./abort";
const getAbortEnhancer = () => {
  return uploader => {
    uploader.update({
      abortAll,
      abortBatch,
      abortItem
    });
    return uploader;
  };
};
export default getAbortEnhancer;